import { render, staticRenderFns } from "./DashInventoryTasks.vue?vue&type=template&id=7246afe2&scoped=true&"
import script from "./DashInventoryTasks.vue?vue&type=script&lang=js&"
export * from "./DashInventoryTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246afe2",
  null
  
)

export default component.exports